// extracted by mini-css-extract-plugin
export default {"form":"page-heading-search_form__4haGu","input":"page-heading-search_input__Yh+QF","submit":"page-heading-search_submit__hYsEA"};